module.exports = __webpack_public_path__ + "static/media/max-speed.00a53100.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/max-speed.svg
// module id = 126
// module chunks = 0